// import React from 'react';
// import { Heart, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin, Shield, FileText } from 'lucide-react';

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   return (
//     <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white mt-16">
//       {/* Main Footer Content */}
//       <div className="max-w-7xl mx-auto px-6 py-12">
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//           {/* About Section */}
//           <div>
//             <div className="flex items-center space-x-2 mb-4">
//               <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center">
//                 <span className="text-white font-black text-xl">+</span>
//               </div>
//               <h3 className="text-xl font-black">PharmaCare</h3>
//             </div>
//             <p className="text-gray-400 text-sm leading-relaxed mb-4">
//               Votre solution complète de gestion pharmaceutique. Modernisez votre pharmacie avec nos outils innovants.
//             </p>
//             <div className="flex space-x-3">
//               <a href="#" className="w-8 h-8 bg-gray-700 hover:bg-emerald-500 rounded-lg flex items-center justify-center transition-all">
//                 <Facebook size={16} />
//               </a>
//               <a href="#" className="w-8 h-8 bg-gray-700 hover:bg-emerald-500 rounded-lg flex items-center justify-center transition-all">
//                 <Twitter size={16} />
//               </a>
//               <a href="#" className="w-8 h-8 bg-gray-700 hover:bg-emerald-500 rounded-lg flex items-center justify-center transition-all">
//                 <Instagram size={16} />
//               </a>
//               <a href="#" className="w-8 h-8 bg-gray-700 hover:bg-emerald-500 rounded-lg flex items-center justify-center transition-all">
//                 <Linkedin size={16} />
//               </a>
//             </div>
//           </div>

//           {/* Quick Links */}
//           <div>
//             <h4 className="text-lg font-black mb-4">Liens Rapides</h4>
//             <ul className="space-y-2">
//               <li>
//                 <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm flex items-center">
//                   <span className="mr-2">→</span> Tableau de bord
//                 </a>
//               </li>
//               <li>
//                 <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm flex items-center">
//                   <span className="mr-2">→</span> Gestion de stock
//                 </a>
//               </li>
//               <li>
//                 <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm flex items-center">
//                   <span className="mr-2">→</span> Point de vente
//                 </a>
//               </li>
//               <li>
//                 <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm flex items-center">
//                   <span className="mr-2">→</span> Commandes laboratoire
//                 </a>
//               </li>
//               <li>
//                 <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm flex items-center">
//                   <span className="mr-2">→</span> Pharmacies de garde
//                 </a>
//               </li>
//             </ul>
//           </div>

//           {/* Support */}
//           <div>
//             <h4 className="text-lg font-black mb-4">Support</h4>
//             <ul className="space-y-2">
//               <li>
//                 <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm flex items-center">
//                   <span className="mr-2">→</span> Centre d'aide
//                 </a>
//               </li>
//               <li>
//                 <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm flex items-center">
//                   <span className="mr-2">→</span> Documentation
//                 </a>
//               </li>
//               <li>
//                 <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm flex items-center">
//                   <span className="mr-2">→</span> FAQ
//                 </a>
//               </li>
//               <li>
//                 <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm flex items-center">
//                   <span className="mr-2">→</span> Tutoriels vidéo
//                 </a>
//               </li>
//               <li>
//                 <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm flex items-center">
//                   <span className="mr-2">→</span> Nous contacter
//                 </a>
//               </li>
//             </ul>
//           </div>

//           {/* Contact Info */}
//           <div>
//             <h4 className="text-lg font-black mb-4">Contact</h4>
//             <ul className="space-y-3">
//               <li className="flex items-start space-x-3">
//                 <MapPin size={18} className="text-emerald-400 flex-shrink-0 mt-0.5" />
//                 <span className="text-gray-400 text-sm">
//                   Rue 10, Angle Avenue Bourguiba<br />
//                   Dakar, Sénégal
//                 </span>
//               </li>
//               <li className="flex items-center space-x-3">
//                 <Phone size={18} className="text-emerald-400 flex-shrink-0" />
//                 <a href="tel:+221771234567" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
//                   +221 77 123 45 67
//                 </a>
//               </li>
//               <li className="flex items-center space-x-3">
//                 <Mail size={18} className="text-emerald-400 flex-shrink-0" />
//                 <a href="mailto:contact@pharmacare.sn" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
//                   contact@pharmacare.sn
//                 </a>
//               </li>
//             </ul>

//             {/* Horaires */}
//             <div className="mt-4 p-3 bg-gray-800 rounded-lg border border-gray-700">
//               <p className="text-xs font-bold text-emerald-400 mb-2">Horaires d'assistance</p>
//               <p className="text-xs text-gray-400">Lun - Ven: 8h00 - 18h00</p>
//               <p className="text-xs text-gray-400">Sam: 9h00 - 13h00</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Bar */}
//       <div className="border-t border-gray-700">
//         <div className="max-w-7xl mx-auto px-6 py-6">
//           <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
//             {/* Copyright */}
//             <div className="flex flex-col md:flex-row items-center md:space-x-2 text-sm text-gray-400 text-center md:text-left">
//               <span>© {currentYear} PharmaCare. Tous droits réservés.</span>
//               <span className="hidden md:inline">•</span>
//               <span className="flex items-center">
//                 Fait avec <Heart size={14} className="mx-1 text-red-500" fill="currentColor" /> au Sénégal
//               </span>
//             </div>

//             {/* Legal Links */}
//             <div className="flex items-center space-x-6 text-sm">
//               <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors flex items-center">
//                 <Shield size={14} className="mr-1" />
//                 Confidentialité
//               </a>
//               <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors flex items-center">
//                 <FileText size={14} className="mr-1" />
//                 Conditions d'utilisation
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;



import React from 'react';
import { Heart, Mail, Phone, MapPin, TrendingUp, Package, Users } from 'lucide-react';

const FooterSimple = () => {
  const currentYear = new Date().getFullYear();

  // return (
  //   <footer className="bg-gray-900 text-white mt-16">
  //     <div className="max-w-7xl mx-auto px-6 py-8">
  //       {/* Main Content */}
  //       <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
  //         {/* Logo & Description */}
  //         <div>
  //           <div className="flex items-center space-x-2 mb-3">
  //             <div className="w-8 h-8 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center">
  //               <span className="text-white font-black text-lg">+</span>
  //             </div>
  //             <h3 className="text-lg font-black">PharmaCare</h3>
  //           </div>
  //           <p className="text-gray-400 text-sm">
  //             Votre solution complète de gestion pharmaceutique
  //           </p>
  //         </div>

  //         {/* Quick Links */}
  //         <div>
  //           <h4 className="font-bold mb-3 text-sm">Navigation</h4>
  //           <div className="grid grid-cols-2 gap-2">
  //             <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">Tableau de bord</a>
  //             <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">Gestion stock</a>
  //             <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">Point de vente</a>
  //             <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">Commandes</a>
  //           </div>
  //         </div>

  //         {/* Contact */}
  //         <div>
  //           <h4 className="font-bold mb-3 text-sm">Contact</h4>
  //           <ul className="space-y-2 text-sm text-gray-400">
  //             <li className="flex items-center space-x-2">
  //               <Phone size={14} className="text-emerald-400" />
  //               <span>+221 77 123 45 67</span>
  //             </li>
  //             <li className="flex items-center space-x-2">
  //               <Mail size={14} className="text-emerald-400" />
  //               <span>contact@pharmacare.sn</span>
  //             </li>
  //             <li className="flex items-start space-x-2">
  //               <MapPin size={14} className="text-emerald-400 mt-0.5" />
  //               <span>Dakar, Sénégal</span>
  //             </li>
  //           </ul>
  //         </div>
  //       </div>

  //       {/* Bottom */}
  //       <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row items-center justify-between space-y-2 md:space-y-0">
  //         <p className="text-sm text-gray-400 flex items-center">
  //           © {currentYear} PharmaCare • Fait avec <Heart size={14} className="mx-1 text-red-500" fill="currentColor" /> au Sénégal
  //         </p>
  //         <div className="flex space-x-4 text-sm">
  //           <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">Confidentialité</a>
  //           <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">CGU</a>
  //         </div>
  //       </div>
  //     </div>
  //   </footer>
  // );

  return (
    <footer className="bg-white border-t-2 border-gray-200 mt-auto">
      <div className="px-6 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-2 md:space-y-0">
          {/* Left - Copyright */}
          <p className="text-sm text-gray-600">
            © {currentYear} <span className="font-bold text-gray-900">SunuFarmasi</span> - Tous droits réservés
          </p>

          {/* Center - Made with love */}
          <p className="text-sm text-gray-600 flex items-center">
            Fait avec <Heart size={14} className="mx-1 text-red-500" fill="currentColor" /> au Sénégal
          </p>

          {/* Right - Links */}
          <div className="flex items-center space-x-4 text-sm">
            <a href="#" className="text-gray-600 hover:text-emerald-600 transition-colors font-semibold">
              Support
            </a>
            <span className="text-gray-300">•</span>
            <a href="#" className="text-gray-600 hover:text-emerald-600 transition-colors font-semibold">
              Confidentialité
            </a>
            <span className="text-gray-300">•</span>
            <a href="#" className="text-gray-600 hover:text-emerald-600 transition-colors font-semibold">
              Version 1.0.0
            </a>
          </div>
        </div>
      </div>
    </footer>
  );

  // return (
  //   <footer className="bg-white border-t-2 border-gray-200 mt-auto">
  //     <div className="px-6 py-4">
  //       {/* Quick Stats Bar */}
  //       <div className="grid grid-cols-3 gap-4 mb-4 pb-4 border-b border-gray-200">
  //         <div className="flex items-center space-x-2">
  //           <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center">
  //             <Users size={16} className="text-emerald-600" />
  //           </div>
  //           <div>
  //             <p className="text-xs text-gray-600">Utilisateurs actifs</p>
  //             <p className="text-sm font-black text-gray-900">124</p>
  //           </div>
  //         </div>

  //         <div className="flex items-center space-x-2">
  //           <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
  //             <Package size={16} className="text-blue-600" />
  //           </div>
  //           <div>
  //             <p className="text-xs text-gray-600">Produits en stock</p>
  //             <p className="text-sm font-black text-gray-900">1,847</p>
  //           </div>
  //         </div>

  //         <div className="flex items-center space-x-2">
  //           <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
  //             <TrendingUp size={16} className="text-purple-600" />
  //           </div>
  //           <div>
  //             <p className="text-xs text-gray-600">Ventes aujourd'hui</p>
  //             <p className="text-sm font-black text-gray-900">42</p>
  //           </div>
  //         </div>
  //       </div>

  //       {/* Footer Bar */}
  //       <div className="flex flex-col md:flex-row items-center justify-between space-y-2 md:space-y-0">
  //         <p className="text-sm text-gray-600">
  //           © {currentYear} <span className="font-bold text-gray-900">PharmaCare</span>
  //         </p>

  //         <p className="text-sm text-gray-600 flex items-center">
  //           Fait avec <Heart size={14} className="mx-1 text-red-500" fill="currentColor" /> au Sénégal
  //         </p>

  //         <div className="flex items-center space-x-4 text-sm">
  //           <a href="#" className="text-gray-600 hover:text-emerald-600 transition-colors font-semibold">
  //             Support
  //           </a>
  //           <span className="text-gray-300">•</span>
  //           <span className="text-gray-600 font-semibold">v1.0.0</span>
  //         </div>
  //       </div>
  //     </div>
  //   </footer>
  // );


  // return (
  //   <footer className="bg-gray-50 border-t border-gray-200 mt-auto">
  //     <div className="px-6 py-3">
  //       <div className="flex items-center justify-between text-xs text-gray-500">
  //         <span>© {currentYear} PharmaCare</span>
  //         <div className="flex items-center space-x-3">
  //           <a href="#" className="hover:text-emerald-600 transition-colors">Support</a>
  //           <span>•</span>
  //           <a href="#" className="hover:text-emerald-600 transition-colors">Documentation</a>
  //           <span>•</span>
  //           <span>v1.0.0</span>
  //         </div>
  //       </div>
  //     </div>
  //   </footer>
  // );
};

export default FooterSimple;